import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';

export default function KeepsakeItem({ item, onRefresh }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(item.name);
  const [description, setDescription] = useState(item.description || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    await supabase.from('keepsakes').update({
      name: name.trim(),
      description: description.trim()
    }).eq('id', item.id);
    setSaving(false);
    setEditing(false);
    onRefresh?.();
  };

  const handleDelete = async () => {
    if (window.confirm('Remove this keepsake?')) {
      await supabase.from('keepsakes').delete().eq('id', item.id);
      onRefresh?.();
    }
  };

  if (editing) {
    return (
      <div className="bg-parchment/70 border border-parchment-dark rounded p-3 space-y-2 mt-1 mb-2">
        <input
          autoFocus
          className="form-input-styled text-[0.82rem] py-1.5 font-medium"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Item name"
        />
        <textarea
          className="form-input-styled text-[0.82rem] py-1.5 min-h-[70px] resize-y leading-relaxed"
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="A note about this keepsake..."
        />
        <div className="flex gap-2 justify-end pt-1">
          <button onClick={() => setEditing(false)} className="font-lora text-[0.76rem] text-ink-mid hover:text-ink transition-colors">cancel</button>
          <button 
            onClick={handleSave} 
            disabled={saving || !name.trim()}
            className="bg-ink text-parchment rounded px-3 py-1 font-lora text-[0.76rem] hover:bg-ink-mid disabled:opacity-50 transition-colors"
          >
            {saving ? 'saving…' : 'save'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="group flex items-start gap-2 py-2.5 border-b border-dashed border-parchment-dark last:border-0 hover:bg-parchment-dark/5 transition-colors -mx-2 px-2 rounded">
      <span className="text-theme-honey mt-[3px] flex-shrink-0 text-[0.75rem]">✦</span>
      <div className="flex-1 min-w-0 pb-0.5">
        <div className="font-lora text-[0.86rem] font-medium text-ink leading-snug">{item.name}</div>
        {item.description && (
          <div className="font-lora text-[0.8rem] text-ink-mid leading-relaxed mt-1.5 whitespace-pre-wrap pl-2.5 border-l-[1.5px] border-theme-honey/40 opacity-90">
            {item.description}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 ml-1">
        <button onClick={() => setEditing(true)} className="font-lora text-[0.72rem] text-ink-mid hover:text-ink bg-parchment border border-parchment-dark rounded px-1.5 py-0.5 shadow-sm transition-colors">✎</button>
        <button onClick={handleDelete} className="font-lora text-[0.72rem] text-theme-roseLight hover:text-theme-rose bg-parchment border border-parchment-dark rounded px-1.5 py-0.5 shadow-sm transition-colors">✕</button>
      </div>
    </div>
  );
}